
import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Home from './pages/Home';
import ScrollToTop from './components/ScrollToTop';

const Library = lazy(() => import('./pages/Library'));
const Pricing = lazy(() => import('./pages/Pricing'));
const Checkout = lazy(() => import('./pages/Checkout'));
const Unsubscribe = lazy(() => import('./pages/Unsubscribe'));
const MyAccount = lazy(() => import('./pages/MyAccount'));
const Login = lazy(() => import('./auth/Login'));
const Signup = lazy(() => import('./auth/Signup'));
const ForgotPassword = lazy(() => import('./auth/ForgotPassword'));
const TermsAndConditions = lazy(() => import('./legal/TermsAndConditions'));
const PrivacyPolicy = lazy(() => import('./legal/PrivacyPolicy'));


function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Suspense fallback={null}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/library" element={<Library />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/unsubscribe" element={<Unsubscribe />} />
            <Route path="/my-account" element={<MyAccount />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          </Routes>
        </Suspense>
      </div>
    </Router>
  );
}

export default App;
